export default function CategoryTabs({ activeTab, setActiveTab }) {
  return (
    <div className="flex space-x-6 text-base font-bold mt-4 font-inter">
      {['Retail', 'Wholesale'].map((tab) => (
        <button
          key={tab}
          onClick={() => setActiveTab(tab)}
          className={`pb-1 ${activeTab === tab ? 'border-b-2 border-[#E7370C]' : 'text-gray-700'}`}
        >
          {tab}
        </button>
      ))}
    </div>
  )
}
